export const UI_TEAM_EDIT = 'UI_TEAM_EDIT'

export function uiTeamEdit (settings, uiState) {
  return {
    type: UI_TEAM_EDIT,
    settings,
    uiState
  }
}
